import { create } from 'zustand'
import { sucursalesSlice } from './slices/sucursalesSlice'
import { formularioCanchasSlice } from './slices/formularioCanchaSlice'

const useCanchasStore = create((set,get) => ({
    error:null,
    isLoading: {cargarSucursalCategoria: true, cargarCancha: true},
    elNavigate:null,
    datos: {
        id:0,
        nombre:"",
        construccion:"Outdoor",
        tiempoUso:"90",
        sucursales:null,
        activo:true
    },
    multiImagenes: [],
    setError: (error) => set({ error }),
    setNavigate: (navigate) => set({ elNavigate: navigate }),
    actualizarId: (id) => set({ datos: { ...get().datos, id } }),
    handleChangeImagen: (e) => set({ multiImagenes: e }),
    handleSucursales: (e) => set({  datos: { ...get().datos, sucursales: e } }),
    handleActivo: (e) => set({ datos: { ...get().datos, activo: e.target.checked } }),
    ...formularioCanchasSlice(set,get),
    ...sucursalesSlice(set,get),
    iniciar: async() => {
        await get().obtenerSucursales();
        await get().obtenerCancha();
        // set({ isLoading: {cargarSucursalCategoria: false, cargarCancha: false} });
    },
    limpiar: () => {
      set({
        isLoading: {cargarSucursalCategoria: true, cargarCancha: true},
        elNavigate:null,
        datos: {
            id:0,
            nombre:"",
            construccion:"Outdoor",
            tiempoUso:"90",
            sucursales:null,
            activo:true
        },
        error:null,
        multiImagenes: []
      })
    }
}))
  
export default useCanchasStore
